module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image15h.6143cc5f.jpg";